/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiDialogActionStyle = (): Components<Theme>["MuiDialogActions"] => ({
  styleOverrides: {
    root: {
      justifyContent: "center",
      padding: "2rem 0 0 0",
    },
  },
});
